export const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
  <g clipPath="url(#clip0_1710_684)">
    <path d="M2.57626 7.81641C2.81063 8.06055 3.19126 8.06055 3.42563 7.81641L5.82563 5.31641C5.99813 5.13672 6.04876 4.86914 5.95501 4.63477C5.86126 4.40039 5.64376 4.24805 5.40001 4.24805L0.600006 4.25C0.358131 4.25 0.138756 4.40234 0.0450062 4.63672C-0.0487438 4.87109 0.00375621 5.13867 0.174381 5.31836L2.57438 7.81836L2.57626 7.81641Z" fill="currentColor"/>
  </g>
  <defs>
    <clipPath id="clip0_1710_684">
      <rect width="6" height="10" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
  </defs>
</svg>
)